import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

/*
  Generated class for the HttpInterceptorProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class HttpInterceptorProvider {

  constructor(public http: HttpClient) {
    console.log('Hello HttpInterceptorProvider Provider');
  }

  post(url: string, body: any | null): Observable<any> {
    var finalURL = ""
    if (url.indexOf("?") > -1) {
      finalURL = url + "&"
    } else {
      finalURL = url + "?"
    }

    return this.http.post(finalURL, body, this.authHeader());
  }

  postQS(url: string, body: any | null): Observable<any> {
    var finalURL = ""
    if (url.indexOf("?") > -1) {
      finalURL = url + "&"
    } else {
      finalURL = url + "?"
    }

    var keys = Object.keys(body)

    keys.forEach(key => {
      finalURL += key + "=" + body[key] + "&" 
    })

    return this.http.post(finalURL, this.authHeader());
  }

  postFile(url: string, body: any | null, options: any | null): Observable<any> {
    return this.http.post(url, body, options);
  }

  put(url: string, body: any | null): Observable<any> {
    return this.http.put(url, body, this.authHeader());
  }

  get(url: string): Observable<any> {
    return this.http.get(url, this.authHeader());
  }

  getFiltered(url: string, filters: Array<Filter>): Observable<any> {

    let filter
    if (filters != undefined) {
      filter = {}

      if (filters.length > 0) {
        filter["filter[meta_query][relation]"] = "AND"
      }

      filters.forEach((element, index) => {

        filter['filter[meta_query][' + index + '][key]]'] = element.field
        filter['filter[meta_query][' + index + '][value]]'] = element.value
        filter['filter[meta_query][' + index + '][compare]]'] = element.comparation

      })

    }

    return this.http.get(url, this.authHeader(filter));
  }

  authHeader(filters?: any): any {
    return {
      headers: new HttpHeaders({
        "Authorization": "Basic YWRtaW46aXRsZWFuMjAxOA==",
        "Content-Type": "application/json",
        "Accept": "application/json",
      }),
      params: filters,
      withCredentials: false
    }
  }
}

export class Filter {
  field: string
  value: string
  comparation: string
}


// WEBPACK FOOTER //
// ./src/providers/http-interceptor/http-interceptor.ts